export var AttendanceStatus;
(function (AttendanceStatus) {
    AttendanceStatus[AttendanceStatus["Present"] = 1] = "Present";
    AttendanceStatus[AttendanceStatus["Absent"] = 2] = "Absent";
    AttendanceStatus[AttendanceStatus["None"] = 3] = "None";
})(AttendanceStatus || (AttendanceStatus = {}));
//# sourceMappingURL=AttendanceItemStatus.js.map